import { PermissionsUrlCreator } from "src/components/Permissions/PermissionTypes";

export const partPermissionsUrlCreator: PermissionsUrlCreator =  {
    SetPermissionUrl: () => `/objectpermission/set`,
    DeletePermissionUrl: () => `/objectpermission/delete`,
    GetstartUrl: (partId:string| number, type:number) => `/objectpermission/get?id=${partId}&type=${type}`,
    GetSearchUrl: ( type: number, partId:string,) => `/objectpermission/list/${partId}/${type}/usersandgroups`
}